import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const ITEMS = ['Aplicar microcemento desde cero paso a paso', 'Evitar errores que arruinan trabajos', 'Cobrar sin regalar tu trabajo', 'Conseguir tus primeros clientes aunque estés empezando', 'Transformar espacios modernos sin demolición', 'Crear muebles premium de microcemento', 'Ofrecer trabajos con alto valor percibido'];
export function WhatYouCanDo() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-t border-white/5" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-204">
          <h2 className="text-4xl md:text-6xl text-white" data-id="element-205">
            LO QUE VAS A PODER <span className="text-brand-yellow" data-id="element-206">HACER</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 mt-4 font-medium" data-id="element-207">
            Con este sistema vas a aprender:
          </p>
        </motion.div>

        <div className="flex flex-col gap-4" data-id="element-208">
          {ITEMS.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-brand-gray border-l-4 border-brand-yellow rounded-xl p-5 flex items-center gap-4" data-id="element-209">
              <Check className="text-brand-yellow w-6 h-6 shrink-0" strokeWidth={3} data-id="element-210" />
              <span className="text-base md:text-lg font-bold text-white text-left" data-id="element-211">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}